import type { ThemeMode } from '../hooks/useTheme.ts';
import { AutoIcon, CrossMark, MoonIcon, NewIcon, SunIcon } from './icons.tsx';

const themeNames: Record<ThemeMode, string> = {
  auto: 'automático',
  light: 'claro',
  dark: 'oscuro',
};

export function Header({
  theme,
  onTheme,
  onNew,
  canReset,
}: {
  theme: ThemeMode;
  onTheme: () => void;
  onNew: () => void;
  canReset: boolean;
}) {
  const button =
    'grid h-11 w-11 place-items-center rounded-full text-cream hover:bg-white/10 ' +
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-300';
  return (
    <header className="bg-purple pt-[env(safe-area-inset-top)] text-cream dark:bg-night-800">
      <div className="mx-auto flex max-w-2xl items-center gap-3 px-4 py-2">
        <span className="text-gold-300">
          <CrossMark />
        </span>
        <div className="min-w-0 flex-1">
          <h1 className="font-serif text-2xl leading-tight tracking-wide">Cruz de IA</h1>
          <p className="text-sm text-cream/85">Semana Santa de Sevilla</p>
        </div>
        {canReset && (
          <button type="button" className={button} onClick={onNew} aria-label="Nueva conversación">
            <NewIcon />
          </button>
        )}
        <button
          type="button"
          className={button}
          onClick={onTheme}
          aria-label={`Tema ${themeNames[theme]}. Cambiar tema`}
          title={`Tema ${themeNames[theme]}`}
        >
          {theme === 'auto' ? <AutoIcon /> : theme === 'light' ? <SunIcon /> : <MoonIcon />}
        </button>
      </div>
    </header>
  );
}
